import React, { useContext, useEffect, useState } from 'react'
import UploadProfile from './UploadProfile'
import { PersonalInfo } from './PersonalInfo'
import { Language } from './Languages'
import { Disability } from './Disability'
import { Layout } from './Layout'
import { compressImage } from "../../../../../utils/compressImages"
import { firstNameValidator, lastNameValidator, fullNameValidator, emailValidator, contactValidator, ageValidator } from "../../../../../utils/validator"
import { DContext } from "../../../../../context/Datacontext";
import { useLocation, useNavigate } from 'react-router-dom'
import { apiFetch } from '../../../../services/fetchApi'
import { ResumeParsing } from '../ResumeParsingFile'

export const PersonalData = ({ candidate, fetchCandidateData, setCandidate, setIsResumeParsing, isResumeParsing }) => {
    const { BeURL, score, currentUser, showAlert } = useContext(DContext)
    const [profile, setProfile] = useState({})
    const [profileInformation, setProfileInformation] = useState({})
    const [language, setLanguage] = useState([])
    const [disability, setDisability] = useState({})
    const maxScore = 100;
    const percentage = (score / maxScore) * 100;
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    // fetch the query:;

    const location = useLocation()
    const queryFetch = new URLSearchParams(location.search)
    const reverse = queryFetch.get('inverse') === "true"
    const previous = location.state?.from || '/account'


    useEffect(() => {
        fetchCandidateData()
    }, [])

    const [errors, setErrors] = useState({});

    const handleProfile = (value) => {
        setProfile(value)
    }
    const handleProfileInformation = (value) => {
        setProfileInformation(value)
    }
    const handleLanguage = (value) => {
        if (value && Array.isArray(value) && value.length) {
            const tempArr = value.map(item => {
                return {
                    ...item,
                    name: item.language,
                    language: undefined // optionally remove 'language' field
                };
            });
            setLanguage(value)
        }
    }
    const handleDisability = (value) => {
        setDisability(value)
    }



    const checkValidation = (field, value, label) => {
        const e = {};

        if (field === "firstname") {
            e[field] = firstNameValidator(value) ? firstNameValidator(value) : ""
        }

        if (field === "lastname") {
            e[field] = (!value) ? "This field is required." : (lastNameValidator(value) || "")
        }

        if (field === "fullname") {
            // e[field] = (!value) ? "This field is required." : (fullNameValidator(value) || "")
            if (!value?.trim()) return; // skip if not yet updated
            e[field] = fullNameValidator(value) || "";
        }

        if (field === "email") {
            e[field] = emailValidator(value) ? emailValidator(value) : ""
        }

        if (field === "alternateemail") {
            if (!!value && !!profileInformation.email && value.toLowerCase() === profileInformation.email.toLowerCase()) {
                e[field] = "Alternate email cannot be same as primary email."
            }
            else {
                e[field] = (value && emailValidator(value)) ? emailValidator(value) : ""
            }
        }

        if (label === "contact") {
            if (field === "countryCode") {
                e.contactCode = (!value) ? "Kindly select any option." : ""
            }
            else if (field === "number") {
                e.contactNumber = contactValidator(value.trim()) ? contactValidator(value) : ""
            }
        }

        if (label === "alternatecontact") {
            if (field === "countryCode") {
                e.alternateContactCode = (!value) ? "Kindly select any option." : ""
            }
            else if (field === "number") {
                if (!!value && !!profileInformation.contact?.number && profileInformation.contact?.number === value) {
                    e.alternateContactNumber = "Alternate contact cannot be same as primary contact."
                }
                else {
                    e.alternateContactNumber = (value) ? (contactValidator(value) || "") : ""
                }
            }
        }

        if (field === "dob") {
            // console.log("values:", value);
            e[field] = (!value) ? "This field is required" : ageValidator(value);
        }

        if (["gender"].includes(field)) {
            e[field] = (!value) ? "This field is required." : ""
        };


        if (field === 'panNumber') {
            if (value) {
                if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i.test(value.trim()))
                    e[field] = "Invalid PAN format (ABCDE1234F)";
                else {
                    e[field] = ""
                }
            }
            else {
                e[field] = ""
            }

        }
        setErrors(prev => {
            let tempError = { ...prev } || {}
            if (Object.keys(e).length) {
                Object.keys(e).forEach(key => {
                    tempError[key] = e[key]
                })
            }
            return tempError
        })

        const errs = Object.values(e).filter(err => err !== "") || []

        return errs.length > 1 ? true : false
    }

    const handleValidation = () => {
        let errStatus = []

        const { firstname, middlename, lastname, fullname, email, alternateemail, contact, alternatecontact, dob, gender, maritalstatus, panNumber } = profileInformation
        const structureProfile = { firstname, middlename, lastname, fullname, email, alternateemail, dob, gender, maritalstatus, panNumber }

        Object.keys(structureProfile).forEach(key => {
            errStatus.push(checkValidation(key, structureProfile[key]))
        })

        errStatus.push(checkValidation("countryCode", contact["countryCode"], "contact"))
        errStatus.push(checkValidation("number", contact["number"], "contact"))
        errStatus.push(checkValidation("countryCode", alternatecontact["countryCode"], "alternatecontact"))
        errStatus.push(checkValidation("number", alternatecontact["number"], "alternatecontact"))

        if (disability.isDisabled && !disability.desc) {
            errStatus.push(true)
            alert("Kindly describe your disability!")
        }

        return errStatus.some(err => err === true)
    }

    const handleSubmit = async () => {
        setLoading(true);

        // console.log("Errors:", errors);
        const Errors = Object.values(errors).filter(Boolean);
        if (handleValidation() || Errors.length) {
            console.log("Errors.length", Errors.length);
            alert("Kindly fill all details!");
            setLoading(false);
            return;
        }

        const formData = new FormData();
        formData.append("profileInformation", JSON.stringify(profileInformation));
        formData.append("disability", JSON.stringify(disability));

        if (candidate._id) formData.append("id", candidate._id);

        if (profile) {
            const compressedFile = await compressImage(profile, { maxSizeMB: 0.7 });
            if (compressedFile) formData.append("profile", compressedFile);
        }

        try {
            const res = await apiFetch(`${BeURL}/candidate-personal-info`, {
                method: "POST",
                body: formData
            });

            const data = await res.json();
            setLoading(false);

            if (data.success) {
                setCandidate(data.candidate);
                await fetchCandidateData();
                // console.log(candidate)  //NOW works
                showAlert(data.message);
                // console.log("reverse", reverse, "previous", previous);

                navigate(`/update-account/skills?candidateId=${candidate?._id}`)

                if (reverse) navigate(previous);

            } else {
                showAlert(data.message);
            }
        }
        catch (err) {
            setLoading(false);
            console.log("Error in submitting Candidate personal information:", err);
            showAlert("Trouble connecting to the Server! Kindly try again later.");
        }
    };

    return (
        <Layout candidate={candidate} isResumeParsing={isResumeParsing}>
            <div className='max-w-7xl mx-auto px-4 w-full py-4 md:py-8 lg:mb-0 mb-14'>
                <div>
                    <ResumeParsing candidate={candidate} setCandidate={setCandidate}  setIsResumeParsing={setIsResumeParsing}/>
                </div>
                <div>
                    <UploadProfile setProfile={handleProfile} url={candidate.profilePicLink || ""} />
                </div>
                <div>
                    <PersonalInfo Information={handleProfileInformation} errors={errors} checkValidation={checkValidation} candidate={candidate} />
                </div>
                <Language Information={handleLanguage} errors={errors} setErrors={setErrors} candidate={candidate} setCandidate={setCandidate} profiles={profileInformation} setProfileInformation={setProfileInformation} />
                <div>
                    <Disability Information={handleDisability} errors={errors} setErrors={setErrors} candidate={candidate} />
                </div>

                <div className="flex flex-col sm:flex-row justify-end items-center gap-4 w-full my-4">

                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={loading}
                        className="w-full sm:w-auto bg-[#2C25C4] text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center"
                    >
                        {reverse ? 'Update' : (loading ? 'Saving...' : 'Next')}
                    </button>
                </div>
            </div>
        </Layout>
    )
}
